export default "__VITE_PUBLIC_ASSET__59f9f8ff__"